import React from 'react';

import { TENANT_ID, TENANT_TO_NAME } from 'global/constants';

import { CIAM_EMAIL_ERROR_TYPES } from 'utils/ciamEmailValidation.utils';
import { getBUEmail, getTenantId } from 'utils/tenantUtil';

const forgotEmail = {
  [TENANT_ID.AVA]:
    'https://account.avacon-netz.de/iconnect/s/login/ForgotPassword?language=de&appID=601007',
  [TENANT_ID.EDI]:
    ' https://account.e-dis-netz.de/iconnect/s/login/ForgotPassword?language=de&appID=601032',
  [TENANT_ID.SHNG]:
    ' https://account.sh-netz.com/iconnect/s/login/ForgotPassword?language=de&appID=601033',
  [TENANT_ID.BAG]:
    'https://account.bayernwerk-netz.de/iconnect/s/login/ForgotPassword?language=de&appID=601036',
  [TENANT_ID.LVN]:
    'https://account.lew-verteilnetz.de/iconnect/s/login/ForgotPassword?appID=601043',
  [TENANT_ID.MTN]:
    'https://account.mitnetz-strom.de/iconnect/s/login/ForgotPassword?language=de&appID=601044',
};

const CIAM_EMAIL_ERRORS = {
  [CIAM_EMAIL_ERROR_TYPES.ACTIVE]: (
    <div>
      Sie haben bereits einen Zugang bei uns/einem unserer Partnerunternehmen und Sie sind im
      Installateurverzeichnis mit Ihrer E-Mail-Adresse eingetragen. Eine Verlängerung/Aktualisierung
      Ihrer Eintragung ist über unser Informationsportal e-fix zu beantragen. Zur Wiederherstellung
      Ihres Passworts nutzen Sie die{' '}
      <a className="link" href={forgotEmail[getTenantId()]}>
        Passwort-Vergessen-Funktion
      </a>
      . Für die Anmeldung rund um einen Netzanschluss steht Ihnen „mein.Auftragsportal“ zur
      Verfügung.
    </div>
  ),
  [CIAM_EMAIL_ERROR_TYPES.PENDING]: (
    <div>
      Ihre E-Mail ist bei uns im System hinterlegt, die Registrierung wurde nicht abgeschlossen.
      Wenden Sie sich bitte per E-Mail an uns, damit wir Ihnen eine neue Registrierungsmail zusenden
      können. Ihr Account wird verwaltet durch uns / unsere Partnerunternehmen:{' '}
      {TENANT_TO_NAME[getTenantId()]}. Kontakt E-Mail zur Klärung:{' '}
      <a className="link" href={`mailto:${getBUEmail()}`}>
        {getBUEmail()}
      </a>
    </div>
  ),
  [CIAM_EMAIL_ERROR_TYPES.DUPLICATE]: (
    <div>
      Sie haben bereits einen Zugang bei uns/einem unserer Partnerunternehmen und Sie sind im
      Installateurverzeichnis mit Ihrer E-Mail-Adresse eingetragen. Wenden Sie sich bitte per E-Mail
      an uns, damit wir Ihren Zugang prüfen und Ihre Freischaltung veranlassen können. Kontakt
      E-Mail zur Klärung:{' '}
      <a className="link" href={`mailto:${getBUEmail()}`}>
        {getBUEmail()}
      </a>
    </div>
  ),
  [CIAM_EMAIL_ERROR_TYPES.ERROR]: (
    <div>
      Leider besteht aktuell ein Fehler in unserem System. Versuchen Sie es bitte zu einem späteren
      Zeitpunkt erneut. Sollte das Problem bestehen bleiben wenden Sie sich bitte an uns:{' '}
      <a className="link" href={`mailto:${getBUEmail()}`}>
        {getBUEmail()}
      </a>
    </div>
  ),
};

export const getCiamEmailErrorContent = (errorType) => CIAM_EMAIL_ERRORS[errorType] || null;

const CIAM_EMAIL_FIELD_ERRORS = {
  [CIAM_EMAIL_ERROR_TYPES.ACTIVE]: 'Diese E-Mail-Adresse ist bereits registriert.',
  [CIAM_EMAIL_ERROR_TYPES.PENDING]:
    'Die Registrierung für diese E-Mail-Adresse wurde nicht abgeschlossen.',
  [CIAM_EMAIL_ERROR_TYPES.DUPLICATE]: 'Die E-Mail-Adresse ist bereits vergeben',
  [CIAM_EMAIL_ERROR_TYPES.ERROR]:
    'E-Mail-Adresse konnte nicht geprüft werden. Bitte versuchen Sie es erneut.',
};

export const getCiamEmailFieldErrorMessage = (errorType) =>
  CIAM_EMAIL_FIELD_ERRORS[errorType] || CIAM_EMAIL_FIELD_ERRORS[CIAM_EMAIL_ERROR_TYPES.ERROR];
